import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { SetCurrentPage } from '../../common/actions/pageAction';
import Pagenation from '../common/Pagenation';
import { DoRoulette, GetRouletteHistory, GetRouletteRules } from '../../common/actions/moreAction';
import { dateFormation, infiniteScroll, isEmpty, isMobilePage } from '../../common/cores';
import Winwheel from '../common/Winwheel';
import { getUserInfo } from '../../common/actions/userActions';

const RouletteContent = props => {
  
  const { page, roulette } = props;
  const history = isEmpty(roulette) || isEmpty(roulette.history) ? [] : roulette.history;
  
  const [ theWheel, setTheWheel ] = useState({});
  const [ winMoney, setWinMoney ] = useState(0);
  const [ allowRoulette, setAllowRoulette ] = useState(true);

//   useEffect(() => {
//     infiniteScroll();
//   }, [])
    
    const getHistory = () => {
        props.GetRouletteHistory(page.curPage);
    }

    const getLottery = (all) => {
    }

    const getWinwheelObject = data => {
        const mode = isMobilePage();
        return new Winwheel({
          'numSegments': data.length,     // Specify number of segments.
          'outerRadius': mode ? 180 : 260,   // Set outer radius so wheel fits inside the background.
          'textFontSize': mode ? 20 : 28,    // Set font size as desired.
          'segments':        // Define segments including colour and text.
            data,
          'animation':           // Specify the animation to use.
          {
            'type': 'spinToStop',
            'duration': 5,     // Duration in seconds.
            'spins': 10,     // Number of complete spins.
          }
        })
      }

      const getColor = (index) => {
        switch (index) {
            case 0: {
                return '#0086E4';
            }
            case 1: {
                return '#FFF';
            }
            default:
                return ;
        }
      }

      const getTextColor = (index) => {
        switch (index) {
            case 0: {
                return '#FFF';
            }
            case 1: {
                return '#0F0080';
            }
            default:
                return ;
        }
      }

    const getFixedRouletteArray = data => {
        let resData = [];
        data.forEach((element, index) => {
        resData.push({
            'fillStyle': getColor(index % 2),
            'text': Number(element.bonus.balance.rolling).toLocaleString() + 'P',
            'textFillStyle': getTextColor(index % 2)
        })
        });
        // console.log(resData);
        return resData;
    }
    
    const sortRouletteList = data => {
        let rouletteList = isEmpty(data) ? [] : data;
        rouletteList.sort((a, b) => {
            return b.bonus.balance.rolling - a.bonus.balance.rolling
        })
        return rouletteList;
    }
    
    const resetWheel = () => {
        let retheWheel = theWheel;
        retheWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
        retheWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
        retheWheel.draw();                // Call draw to render changes to the wheel.
        setTheWheel(retheWheel);
    }
    
    const StartSpin = () => {
        
        setWinMoney(0);
        if(allowRoulette){
            setAllowRoulette(false);
            let changeTheWheel = theWheel;
            console.log('changeTheWheel: ', changeTheWheel);
            resetWheel();
            changeTheWheel.stopAnimation(false);
            
            props.DoRoulette()
            .then(history => {
                
                if (history.success === false){
                    throw (history.err);
                }
                
                let rouletteList = isEmpty(roulette) && isEmpty(roulette.roulette) ? [] : sortRouletteList(roulette.roulette.list);
                
                const index = rouletteList.findIndex(item => item.bonus.balance.rolling === history.bonus.balance.rolling);
                if (index < 0)
                return;
                
                
                let stopAt = changeTheWheel.getRandomForSegment(index + 1);
                changeTheWheel.animation.stopAngle = stopAt;
                changeTheWheel.startAnimation();
                
                setTimeout(() => {
                    props.GetRouletteHistory(1);
                    props.getUserInfo();
                    setWinMoney(history.bonus.balance.rolling);
                    setAllowRoulette(true);
                }, 5000);
                
            }).catch(err => {
                console.log("err", err)
            })
            
            
            setTheWheel(changeTheWheel)
        }
    }
    
    useEffect(() => {
      getHistory();
      props.GetRouletteRules().then(roulette => {
        let rouletteList = sortRouletteList(roulette.roulette);
        // console.log(rouletteList);
        let theWheel = getWinwheelObject(getFixedRouletteArray(rouletteList));
        setTheWheel(theWheel);
      }).catch(err => {
        console.log('err: ', err);
        
      });
    }, [page.curPage, page.perPage]);

    const onSetPage = (page) => {
        props.SetCurrentPage({
            page: Number(page),
            totalPage: props.page.totalPage
        })
    }

    
    const canvasSize = isMobilePage() ? 360 : 536;

  return (
    <Fragment>
      <div data-v-8a9c4d9d="" className="rightContent homePage" style={{ float: "left", width: "100%" }}>
            <div data-v-8a9c4d9d="" className="contents" style={{ maxWidth: "1920px", margin: "auto" }}>
                <div data-v-8a9c4d9d="" className="main_content_continer">
                    <div data-v-7f3aef84="" data-v-8a9c4d9d="" className="main-content">
                        <div data-v-7f3aef84="" className="aniFrame">
                            <div data-v-7f3aef84="" className="main_content roulette-back"> 
                              <div data-v-0838e822="" className = "main_content v_deep_deposit">
                                    <div data-v-0838e822="" className = "main_content_wrap main_content_wrap_notice deposit">
                                        <div data-v-0838e822="">
                                            <div data-v-0838e822="" className = "fundFrame noticeFrame">
                                              <div  data-v-0838e822="" className="d-flex m-d-block">
                                                  
                                                <div className="w-60 m-w-100">
                                                  <div data-v-35afea22="" className="box_lottery padding-40px-tb flex-wrap roulette_wrap d-block">

                                                    <div className="titlebox  padding-15">
                                                      <div className="roulettebox aos-init aos-animate" data-aos="fade-up" data-aos-delay="600" data-aos-duration="500">
                                                          <div className="labelgrp">
                                                              <div className="label aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                                                                  남은 룰렛이벤트&emsp;
                                                                  <span id="roulette_coupon">{isEmpty(roulette.leftCount) ? 0 : roulette.leftCount }&nbsp;</span>개
                                                              </div>
                                                              <div className="result_point">
                                                                  <div className="label">당첨포인트</div>
                                                                  <div className="value" >{Number(winMoney).toLocaleString()}&nbsp;</div>
                                                                  <div className="label">P</div>
                                                              </div>
                                                          </div>  
                                                      </div>
                                                    </div>

                                                    <section id="roulette">
                                                        <canvas id="canvas" className="roulette_rotate_plate" width={canvasSize} height={canvasSize}></canvas>
                                                        <div className="shadow_box"></div>
                                                        <img className="roulette_center_cover" src="../images/more/roulette_center_cover.png" alt=""  
                                                            onClick={e => { e.preventDefault(); StartSpin(); }}/>
                                                        <img className="roulette_center_cover roulette_center_cover_ring" src="../images/more/roulette_center_cover_ring.png" alt="" />
                                                        <img className="roulette_arrow" src="../images/more/roulette_arrow.png" id="roulette_rotate_plate" alt="" />
                                                        {/* <div className="btn_play d-block" onClick={e => { e.preventDefault(); StartSpin(); }}>
                                                          룰렛돌리기<div className="effect"></div>
                                                        </div> */}
                                                      {/* <div data-v-3bc0937f="" class="coin aniLogo"></div> */}
                                                    </section>
                                                    </div>
                                                </div>
                                                  
                                                <div className="w-40 m-w-95 d-flex justify-content-center">
                                                    <div className="contents_box padding-15">
                                                        <div className="con_box00">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                    <th className="list_title1">번호</th>
                                                                    <th className="list_title1">사용일시</th>
                                                                    <th className="list_title1">당첨내역</th>
                                                                    </tr>
                                                                    {
                                                                    !isEmpty(history) && history.map((list, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="list1" style={{minWidth: "40px"}}>{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>
                                                                                <td className="list1">{dateFormation(list.used_date)}</td>
                                                                                <td className="list1">{!list.bonus ? "0" : Number(list.bonus.balance.rolling).toLocaleString()}P</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            
                                                        </div>
                                                        {
                                                            history.length !== 0 ?
                                                            <Pagenation 
                                                                page={page.curPage}
                                                                totalPage={page.totalPage}
                                                                getPage={onSetPage}
                                                                    />
                                                                : ""
                                                        } 
                                                    </div>
                                                    
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
      
      </Fragment>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated, 
  roulette: state.more.roulette,
  page: state.page,
});

export default connect(
  mapStateToProps,
  { 
    SetCurrentPage, 
    GetRouletteHistory, 
    GetRouletteRules, 
    DoRoulette, 
    getUserInfo
   }
)(RouletteContent);



// WEBPACK FOOTER //
// ./src/components/account/RouletteContent.js